export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-1440w.42ea14b6.png";